import React from "react";
import { withRouter } from "react-router-dom";
import "../../../src/assets/scss/intel.scss";
import trackingEventDictionary from "../../../src/core/dictionary/tracking-event";
import { hsCodeTypeDictionary } from "../../../src/core/global/global-country-dictionary";
import { generateTrackingObject } from "../../../src/core/global/global-country-functions";
import { trademoTrackingEvents } from "../../../src/core/global/trademo-tracking";
import { getIntelUrl } from "../../utils/intelUrl";
import { connect } from "react-redux";
import { setRedirectionIdsArrayHandler } from "@redux/User/userDetailsSlice";
import { isProfileAccess } from "@helpers/profileHelper";
import { SHOW_GLOBAL_DATA_HS_CODE_LINK } from "@core/dictionary/global";

const finiteArrayCount = 4;
class HSCodeText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hsCodeText: "",
      hsCodeArray: [],
      sliceLength: this.mapSliceLength(),
      readMoreText: true,
      isBlocked: this.props,
    };
  }
  // Below is the code used at the mounting stage of the component
  componentDidMount() {
    this.mapHSCodeTextData();
  }
  // End of the above code
  // Below code is used for mapping the slice Length
  mapSliceLength = () => {
    let returnData = 0;
    if (this.props.type === hsCodeTypeDictionary.shipment) {
      returnData = this.props.hsCodeFieldObject.sliceLength;
    } else {
      returnData = this.props.sliceLength;
    }
    return returnData;
  };
  // End of the above code
  // Below Code is for the mapping the hs Code Text
  mapHSCodeTextData() {
    let returnData = "";
    if (this.props.type === hsCodeTypeDictionary.shipment) {
      const rowData = this.props.rowData;
      const fieldData = Array.isArray(this.props.hsCodeFieldObject) ? this.props.hsCodeFieldObject.flat(10) : this.props.hsCodeFieldObject;
      if (!!fieldData.alternateValueCheckField && fieldData.alternateValueCheckField !== "" && rowData[fieldData.alternateValueCheckField] === true) {
        returnData = rowData[fieldData.alternateSelector];
      } else if (!!rowData[fieldData.alternateSelector] && rowData[fieldData.alternateSelector] !== "" && (!rowData[fieldData.selector] || rowData[fieldData.selector] === "")) {
        returnData = rowData[fieldData.alternateSelector];
      } else {
        returnData = fieldData && fieldData.selector && rowData[fieldData.selector] && typeof rowData[fieldData.selector] === "string" ? rowData[fieldData.selector].replaceAll(",", ", ") : rowData[fieldData.selector];
      }
    } else if (this.props.type === hsCodeTypeDictionary.conditionalViewShipment) {
      returnData = Array.isArray(this.props.hsCodeFieldObject) ? this.props.hsCodeFieldObject.flat(10).join(",") : this.props.hsCodeFieldObject;
    } else if (this.props.type === hsCodeTypeDictionary.viewShipment) {
      returnData = Array.isArray(this.props.hsCodeFieldObject) ? this.props.hsCodeFieldObject.flat(10).join(",") : this.props.hsCodeFieldObject;
    }
    const hsCodeArray = returnData && typeof returnData === "string" ? (this.props.isReadMore ? returnData?.split(",") : returnData?.split(",")?.slice(0, finiteArrayCount)) : [];
    this.setState({
      hsCodeText: returnData,
      hsCodeArray,
    });
  }
  // End of the above code
  mapHSCodeRedirectionUrl = (data) => {
    let returnUrl = "";
    if (!!data && data !== "") {
      const sendingData = data + "";
      this.props.setRedirectionIdsArrayHandler(sendingData);

      let country = this.props.countryName ? (this.props.countryName.toLowerCase() === "united states" ? "us" : this.props.countryName.toLowerCase() === "united kingdom" ? "uk" : this.props.countryName.toLowerCase()) : "us";
      returnUrl = getIntelUrl() + "hs-code/" + sendingData.trim() + "?country=" + country + "&type=" + this.props.countryType;
    }
    if (this.props.type === hsCodeTypeDictionary.shipment) {
      if (this.props.showHSLabel) trademoTrackingEvents(trackingEventDictionary.hsCodeProfileRedirectionFromAutosuggest, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
      else trademoTrackingEvents(trackingEventDictionary.shipmentsTabHsCodeProfileClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    } else if (this.props.type === hsCodeTypeDictionary.conditionalViewShipment || this.props.type === hsCodeTypeDictionary.viewShipment) {
      trademoTrackingEvents(trackingEventDictionary.shipmentsTabViewShipmentHsCodeProfileClick, generateTrackingObject(this.props.analyticsCountryID, this.props.pathname, this.props.currentUserPlan));
    }
    if (window.location.href.includes("multicountry")) {
      if (returnUrl) window.open(returnUrl + "&viewType=aggregate");
    } else {
      if (returnUrl) window.open(returnUrl);
    }
  };

  ReadMoreHSCode = (isProfileBlocked) => {
    const toggleReadMore = () => {
      this.setState({ readMoreText: !this.state.readMoreText });
    };

    const getHSCodeArray = () => {
      return this.state.readMoreText ? this.state.hsCodeArray.slice(0, finiteArrayCount) : this.state.hsCodeArray;
    };
    return (
      <div className="read-more-cards">
        {getHSCodeArray().map((item, index) => {
          return (
            <a className={`${isProfileBlocked ? "" : "btn-link trademo-link"} ${this.props.redirectionIdsArr.includes(item) && !isProfileBlocked ? "text_visited" : ""} `} onClick={isProfileBlocked ? () => null : () => this.mapHSCodeRedirectionUrl(item)} target="_blank" key={item}>
              {item}
              {index !== this.state.hsCodeArray.length - 1 ? ", " : ""}
            </a>
          );
        })}
        <span onClick={toggleReadMore}>{this.state.readMoreText ? <span className="read-more-link"> Read more</span> : <span className="read-more-link"> Show less </span>}</span>
      </div>
    );
  };

  render() {
    const isProfileBlocked = !isProfileAccess("hsCode")?.hsCode;

    return (
      <span>
        <span data-tip={!!this && !!this.state && !!this.state.hsCodeText && this.state.hsCodeText !== "" ? this.state.hsCodeText : ""} data-for="hs-code-inline-tooltip">
          {!!this && !!this.state && !!this.state.hsCodeArray && this.state.hsCodeArray.length !== 0 && Array.isArray(this.state.hsCodeArray) === true ? (
            this.props.isReadMore && this.state?.hsCodeArray?.length > finiteArrayCount ? (
              <span className="bold-data">{this.ReadMoreHSCode(isProfileBlocked)}</span>
            ) : (
              <>
                {this.state.hsCodeArray.map((item, index) => {
                  return this.props.countryName?.toUpperCase() === "GLOBAL DATA" && !SHOW_GLOBAL_DATA_HS_CODE_LINK ? (
                    <span>
                      {this.props.showHSLabel ? "HS: " : ""}
                      {item}
                      {index !== this.state.hsCodeArray.length - 1 ? ", " : ""}
                    </span>
                  ) : (
                    <a className={`${isProfileBlocked ? "tw-cursor-text tw-no-underline hover:tw-text-gray-900 tw-text-inherit" : "btn-link trademo-link"} ${this.props.redirectionIdsArr.includes(item) && !isProfileBlocked ? "text_visited" : ""}`} onClick={isProfileBlocked ? () => null : () => this.mapHSCodeRedirectionUrl(item)} target="_blank" key={item}>
                      {this.props.showHSLabel ? "HS: " : ""}
                      {item}
                      {index !== this.state.hsCodeArray.length - 1 ? ", " : ""}
                    </a>
                  );
                })}{" "}
                {this.props.type === hsCodeTypeDictionary.shipment && !!this && !!this.state && !!this.state.hsCodeArray && this.state.hsCodeArray.length > finiteArrayCount ? "..." : ""}
              </>
            )
          ) : (
            <span>NA</span>
          )}
        </span>
      </span>
    );
  }
}
function mapStateToProps(state) {
  const { userDetails } = state;
  const creditDetails = state.userDetails.creditDetails;
  return { redirectionIdsArr: userDetails?.redirectionIdsArr ?? [], creditDetails: creditDetails };
}
const mapDispatchToProps = {
  setRedirectionIdsArrayHandler: (data) => setRedirectionIdsArrayHandler(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HSCodeText));
